import { WagtailImageRendition } from '@/types';
import Image from 'next/image';
import Picture from '@components/Picture/Picture';
import AiLabel from '@components/AiLabel';
import { addBaseUrl } from '@utils/url';

interface Props {
  image: WagtailImageRendition;
  mobileImage?: WagtailImageRendition | null;
}

function BannerImage(props: Props) {
  const { image, mobileImage } = props;

  return (
    <div className='banner-image'>
      {mobileImage ? (
        <Picture
          fill
          image={addBaseUrl(image.url)}
          mobileImage={addBaseUrl(mobileImage.url)}
          common={{ alt: image.alt, width: image.width, height: image.height }}
          sizes='100vw'
        />
      ) : (
        <Image
          src={addBaseUrl(image.url)}
          alt={image.alt}
          width={image.width}
          height={image.height}
        />
      )}
      <AiLabel label={image.ai_label} position='top-left' />
    </div>
  );
}

export default BannerImage;
